import { useNavigate } from 'react-router-dom'
import '../Styles/Menu.css'
import logox from '../Assets/logo-x.webp'
import Exit from './Exit'

const Menu = ({ activeSection }) => {
  const navigate = useNavigate()

  const redirectSection = (e, id) => {
    e.preventDefault()
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <aside id="left-menu" className="sidebar box-shadow">
      <div onClick={() => navigate('/home')} className="flex-center flex-column cursor-pointer">
        <div id="logo-x-img">
          <img src={logox} />
        </div>
        <h2 className="text-center">
          Grupo <span>Fixx</span>
        </h2>
      </div>
      <nav className="flex-center flex-column">
        <a
          className={activeSection === 'Fixxinvest' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'Fixxinvest')}
        >
          Fixxinvest
        </a>
        <a
          className={activeSection === 'FixxBank' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'FixxBank')}
        >
          Fixxbank
        </a>
        <a
          className={activeSection === 'FixxCapital' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'FixxCapital')}
        >
          Fixxcapital
        </a>
        <a
          className={activeSection === 'FxVidroEsquadrias' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'FxVidroEsquadrias')}
        >
          Fx Vidros e Esquadrias
        </a>
        <a
          className={activeSection === 'AgroFixx' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'AgroFixx')}
        >
          Agro Fixx
        </a>
        <a
          className={activeSection === 'Chicken in House' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'Chicken in House')}
        >
          Chicken in House
        </a>
        <a
          className={activeSection === 'Star Agency' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'Star Agency')}
        >
          Star Agency
        </a>
        <a
          className={activeSection === 'Star Corporate' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'Star Corporate')}
        >
          Star Corporate
        </a>
        <a
          className={activeSection === 'AGTEK' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'AGTEK')}
        >
          Agtek
        </a>
        <a
          className={activeSection === 'Nexx Fixx' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'NexxFixx')}
        >
          NexxFixx
        </a>
        <a
          className={activeSection === 'MCompany' ? 'active' : ''}
          onClick={(e) => redirectSection(e, 'MCompany')}
        >
          MCompany
        </a>
      </nav>

      <Exit/>
    </aside>
  )
}

export default Menu
